import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.object.is-extensible";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.object.is-extensible";

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}
/** @jsx jsx */


import { jsx } from 'theme-ui';
import * as styles from './styles';
import { Search } from '../Icons';
import { jsx as ___EmotionJSX } from "@emotion/core";
export var NavSearch = function NavSearch(props) {
  return jsx("div", {
    sx: styles.wrapper,
    "data-testid": "nav-search"
  }, jsx(Search, {
    size: 20,
    sx: styles.icon
  }), jsx("input", _extends({}, props, {
    sx: styles.input
  })));
};

if (typeof NavSearch !== 'undefined' && NavSearch && NavSearch === Object(NavSearch) && Object.isExtensible(NavSearch) && !NavSearch.hasOwnProperty('__filemeta')) {
  Object.defineProperty(NavSearch, '__filemeta', {
    configurable: true,
    value: {
      name: "NavSearch",
      filename: "node_modules/gatsby-theme-docz/src/components/NavSearch/index.js"
    }
  });
}